(() => {
  const instances = new WeakMap();

  const init = (scope = document) => {
    scope.querySelectorAll('[data-get-quote-highlights]').forEach((slider) => {
      const media = window.matchMedia('(max-width: 989px)');

      const update = () => {
        const instance = instances.get(slider);
        if (media.matches && !instance && window.Splide) {
          const nextInstance = new window.Splide(slider, {
            type: 'slide',
            autoWidth: true,
            arrows: false,
            pagination: false,
            drag: true,
            gap: 0,
            perMove: 1,
          });
          nextInstance.mount();

          const pagination = document.createElement('ul');
          pagination.className = 'splide__pagination get-quote-banner__pagination';
          pagination.setAttribute('role', 'tablist');
          pagination.setAttribute('aria-label', 'Select service highlights');

          [0, nextInstance.Components.Controller.getEnd()].forEach((targetIndex, dotIndex) => {
            const item = document.createElement('li');
            const button = document.createElement('button');
            button.type = 'button';
            button.className = `splide__pagination__page${dotIndex === 0 ? ' is-active' : ''}`;
            button.setAttribute('aria-label', `Go to highlight group ${dotIndex + 1}`);
            button.addEventListener('click', () => nextInstance.go(targetIndex));
            item.appendChild(button);
            pagination.appendChild(item);
          });

          slider.appendChild(pagination);
          nextInstance.on('moved', (newIndex) => {
            pagination.querySelectorAll('.splide__pagination__page').forEach((button, dotIndex) => {
              button.classList.toggle('is-active', dotIndex === (newIndex === 0 ? 0 : 1));
            });
          });
          instances.set(slider, nextInstance);
        } else if (!media.matches && instance) {
          instance.destroy(true);
          slider.querySelector('.get-quote-banner__pagination')?.remove();
          instances.delete(slider);
        }
      };

      media.addEventListener('change', update);
      update();
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
